module.exports = __webpack_public_path__ + "static/media/comingSoon.2b4dbb48.png";